// Raid boss bar (RAID, UI-4; M14.2). A top-centre banner shown while a raid is
// active: the wave number and a red bar that empties as its raiders are cut down.
// Client-only (ENG-1); reads the sim's raid snapshot through game.raidInfo().
// Diff-based — the DOM is touched only when a value actually changes.
import { h } from '../h';
import type { Game } from '../../boot';

export class BossBar {
  readonly el: HTMLElement;
  private readonly label: HTMLElement;
  private readonly fill: HTMLElement;
  private lastText = '';
  private lastPct = -1;
  private shown = false;

  constructor() {
    this.label = h('div', { class: 'bb-bossbar-label' });
    this.fill = h('div', { class: 'bb-bossbar-fill' });
    const track = h('div', { class: 'bb-bossbar-track' }, this.fill);
    this.el = h('div', { class: 'bb-bossbar' }, this.label, track);
    this.el.style.display = 'none';
  }

  update(game: Game): void {
    const raid = game.raidInfo();
    const show = raid !== null && raid.status === 'active';
    if (show !== this.shown) { this.el.style.display = show ? 'flex' : 'none'; this.shown = show; }
    if (!raid || !show) return;
    const text = `Raid — Wave ${raid.wave} of ${raid.totalWaves}`;
    if (text !== this.lastText) { this.label.textContent = text; this.lastText = text; }
    const pct = raid.waveTotal > 0 ? Math.round((raid.alive / raid.waveTotal) * 100) : 0;
    if (pct !== this.lastPct) { this.fill.style.width = `${pct}%`; this.lastPct = pct; }
  }
}
